import { useParams } from 'react-router-dom';
import { authService } from '../../../services/authService';

const AuthLink = () => {
  const { link } = useParams();

  authService
    .checkAuthLink({
      link: link
    })
    .then((res) => {
      if (res.data.access_token) {
        localStorage.setItem('access_token', res.data.access_token);
      }
      if (res.data.refresh_token) {
        localStorage.setItem('refresh_token', res.data.refresh_token);
      }

      window.location.pathname = '/profile/edit';
    })
    .catch((err) => console.log('error', err));
};
export default AuthLink;
